import React from 'react';
import { SerializedStyles } from '@emotion/react';
import { Select as MUISelect } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import { color } from '../../../styles';

interface Props {
  id?: string;
  listData: MenuItemProps[]; // 一覧に表示するリストデータ
  value?: MenuItemProps | string | number | null; // 初期値として使用
  label?: string; // フォームの説明文
  isError?: boolean; // フォームがErrorの場合
  isDisplayEmpty?: boolean; // 空の値のとき、明示的に表示するか
  errorText?: string; // Error時に表示するヘルプテキスト
  disabled?: boolean; // フォームを無効化するかどうか
  className?: SerializedStyles; // コンポーネントに適用するEmotionCSS
  style?: React.CSSProperties; // Formに指定するCSSProps
  fullWidth?: boolean;
  isEmptyValue?: boolean; // 空データ（未選択）かどうか（trueのときに選択肢の色をグレーにする）
  onChange: (value: MenuItemProps) => void;
}

export interface MenuItemProps {
  key: number | string;
  value: string;
  disabled?: boolean; // MenuItemで選択を無効化したい場合に指定
  option?: any;
}

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 400,
    },
  },
};

export const Select = React.memo(
  ({
    id,
    listData,
    value,
    label = '',
    isError = false,
    isDisplayEmpty = false,
    errorText = '',
    disabled = false,
    className,
    style,
    fullWidth = false,
    isEmptyValue = false,
    onChange,
  }: Props) => {
    const [displayText, setDisplayText] = React.useState('');
    const [helperText, setHelperText] = React.useState<string>('');

    React.useEffect(() => {
      if (isError) {
        setHelperText(errorText);
      } else {
        setHelperText('');
      }
    }, [isError]);

    const handleChange = (data: MenuItemProps) => {
      setDisplayText(data.key as string);
      onChange(data);
    };

    React.useEffect(() => {
      if (typeof value !== 'number' && !value) {
        setDisplayText('');
        return;
      }
      if (typeof value === 'object' && value !== null) {
        setDisplayText(value.key as string);
        return;
      }
      setDisplayText(value as string);
    }, [listData, value]);

    return (
      <>
        {listData && (
          <FormControl style={style} fullWidth={fullWidth}>
            <InputLabel id={id + '-label'}>{label}</InputLabel>
            <MUISelect
              style={{ background: '#fff' }}
              id={id}
              labelId={id + '-label'}
              label={label}
              value={displayText}
              css={className}
              disabled={disabled}
              MenuProps={MenuProps}
              error={isError}
              displayEmpty={isDisplayEmpty}
              sx={isEmptyValue ? { color: color.thin_gray } : {}}
            >
              {listData.map((data: MenuItemProps, i: number) => {
                return (
                  <MenuItem key={i} value={data.key} disabled={data.disabled} onClick={() => handleChange(data)}>
                    {data.value}
                  </MenuItem>
                );
              })}
            </MUISelect>
            {helperText && <FormHelperText sx={{ color: '#d32f2f' }}>{helperText}</FormHelperText>}
          </FormControl>
        )}
      </>
    );
  }
);
